import { ArticleTable } from '@/components/article-table';

import { AssetServicesTable } from '../asset-service-table';

export const Organize = () => (
    <>
        <AssetServicesTable />
        <ArticleTable />
    </>
);
